import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../../contexts/NotificationsContext';

/** lot DJ — message en haut de page, non collant, sous la barre du haut. */
export const BandeauNotifications = () => {
  const { bandeau, fermerBandeau } = useNotifications();
  const navigate = useNavigate();
  if (!bandeau) return null;

  return (
    <div
      data-testid="bandeau-notifications"
      className="w-full flex items-center justify-between gap-3 px-4 md:px-5 lg:px-6"
      style={{ backgroundColor: '#FEF3C7', borderBottom: '1px solid #FCD34D', minHeight: 44,
        color: '#78350F' }}
    >
      <p className="text-sm py-2">
        <span className="hidden md:inline">Vous avez de nouvelles notifications. </span>
        <span className="md:hidden">Nouvelles notifications. </span>
        <button
          type="button"
          onClick={() => navigate('/notifications')}
          data-testid="bandeau-notifications-voir"
          className="underline font-semibold"
          style={{ color: '#0062CC' }}
        >
          <span className="hidden md:inline">Voir les notifications</span>
          <span className="md:hidden">Voir</span>
        </button>
      </p>
      <button
        type="button"
        onClick={fermerBandeau}
        data-testid="bandeau-notifications-fermer"
        className="text-sm font-semibold shrink-0 flex items-center justify-center"
        style={{ color: '#78350F', minWidth: 44, minHeight: 44 }}
      >
        Fermer ✕
      </button>
    </div>
  );
};

export default BandeauNotifications;
